// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Blog$BenfaerberBlog from "../lib/Blog.bs.js";
import * as Flag$BenfaerberBlog from "./Flag.bs.js";
import * as Tags$BenfaerberBlog from "./Tags.bs.js";
import * as Author$BenfaerberBlog from "./Author.bs.js";
import * as ReactRouterDom$BenfaerberBlog from "../wrappers/ReactRouterDom.bs.js";

function s(prim) {
  return prim;
}

function ArticleItem(props) {
  var article = props.article;
  var slug = article.slug;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs(ReactRouterDom$BenfaerberBlog.Link.make, {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("h1", {
                                                    children: article.title
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    children: Belt_Array.mapWithIndex(article.languages, (function (i, lang) {
                                                            return JsxRuntime.jsx(Flag$BenfaerberBlog.make, {
                                                                        language: lang,
                                                                        className: "article-flag"
                                                                      }, String(i));
                                                          })),
                                                    className: "article-flags is-flex is-align-items-center ml-2"
                                                  })
                                            ],
                                            className: "is-flex is-align-items-center"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(Tags$BenfaerberBlog.make, {
                                                  tags: article.tags
                                                })
                                          })
                                    ],
                                    className: "is-flex is-justify-content-space-between"
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: article.description
                                  }),
                              JsxRuntime.jsx(Author$BenfaerberBlog.make, {
                                    date: Blog$BenfaerberBlog.convertDatestamp(article.date)
                                  })
                            ],
                            className: "column"
                          }),
                      JsxRuntime.jsx("div", {
                            className: "column is-one-fifth-desktop is-half-mobile is-one-third-tablet is-hidden-mobile"
                          })
                    ],
                    href: "/blog/" + slug,
                    className: "columns"
                  }),
              className: "article-item"
            }, slug);
}

var make = ArticleItem;

export {
  s ,
  make ,
}
/* react/jsx-runtime Not a pure module */
